
import { Component} from '@angular/core';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html'
})
export class AlertDialogComponent  {

    public title: string;
    public message: string;
    public okButton = 'OK';

    constructor() {

    }

}



// WEBPACK FOOTER //
// ./src/app/shared/dialogs/alert-dialog/alert-dialog.component.ts